import { render } from "./ContentToPrint.vue?vue&type=template&id=6c421ed1"
import script from "./ContentToPrint.vue?vue&type=script&lang=js"
export * from "./ContentToPrint.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__